import { useEffect, useState, type FunctionComponent, } from "react"
import { createPortal, } from "react-dom";
import { useMessengerStore,  } from "./MessengerStore";
import * as IC from "@bracket/react-icons";

import type { MessageProps, MessageSeverity, } from "./types";
import "./Messenger.scss";



export declare type MessengerProps = {
	/** DOM selector which will act as a parent for this messenger */
	parent?: string;
	icon_success?: keyof typeof IC;
	icon_fail?: keyof typeof IC;
	icon_warning?: keyof typeof IC;
};



export const Messenger: FunctionComponent<MessengerProps> = ({
	parent = "body",
}) => {

	const { messages, } = useMessengerStore();

	useEffect(() => {
		const parentNode = document.querySelector(parent);
		if( parentNode ) {
			const node = document.createElement('div');
			const exists = parentNode.querySelector("#messenger-overlay");
			node.id = "messenger-overlay";
			if( !exists ) {
				parentNode.appendChild(node);
			}
		}
	}, []);

	return <>{ messages.map(( message, idx) => <Message key={idx} {...message} /> )}</>;

}


export const Message = ({
	title,
	message,
	severity,
	parent = "#messenger-overlay",
	duration = 10000,
	id,
	blockChainLink,
}: MessageProps & { parent?: string; }) => {


	const parentNode = document.querySelector(parent);
	const [ phase, setPhase ] = useState<"new" | "alive" | "dead">("new");
	const classes = [ `message`, severity, phase, ].join(" ");
	const { icon_success, icon_failure, expire, } = useMessengerStore();
	const Icon: any = severity === "success" ? IC[icon_success] : severity === "error" ? IC[icon_failure] : IC[icon_success];
	const CloseIcon: any = IC["Cross"];

	const onClose = () => {
		expire(id);
	};

	useEffect(() => {
		setTimeout(() => setPhase("alive"), 0);
		setTimeout(() => setPhase("dead"), duration - 1000);
	}, []);

	if( parentNode ) { 
		return createPortal(
			<div className={classes}>
				<div className="icon">
					<img src={`/assets/messenger-${severity}-icon.png`} />
					{/* <Icon /> */}
				</div>
				<div className="content">
					<div className="title">{title}</div>
					<div className="information">{message}</div>
					{ blockChainLink && <div className="link"><a href={blockChainLink.link} target="_blank">{blockChainLink.text}</a></div> }
				</div>
				<div className="actions">
					<div className="close" onClick={onClose}><CloseIcon /></div>
				</div>
			</div>,
			parentNode
		);
	}
	throw new Error("Message:: parent not ready");

}
